module.exports = __webpack_public_path__ + "img/footer@2x.4b17bbe3.png";